/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { Component, Inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Component that loads the MacMillan book content component.
 */
@Component({
  selector: 'macmillan-book-dialog',
  templateUrl: './macmillan-book-dialog.component.html',
  standalone: false,
})
export class MacmillanBookDialogComponent {
  /**
   * The id of the selected MacMillan book.
   */
  public selectedBook : string;

  /**
   * Boolean indicating whether or not a book has been selected.
   */
  public bookSelected : boolean = false;

  /**
   * Default Constructor.
   *
   * @param dialogRef Reference to the open dialog.
   * @param config Dialog configuration.
   * @param state
   * @param BulbGroupService
   */
  constructor(
    public dialogRef : DynamicDialogRef,
    public config: DynamicDialogConfig,
    @Inject('$state') private state,
    @Inject('BulbGroupService') private BulbGroupService,
  ) {}

  /**
   * Method that changes the state of the 'continue' button upon selecting a MacMillan book.
   */
  imageSelected() : void {
    this.bookSelected = true;
  }

  /**
   * Close the modal, submitting the value of the selected book. And performing the logic to handle the redirection
   * and onboarding to the new group.
   */
  continue() : void {
    this.dialogRef.close(this.selectedBook);
    // @ts-ignore
    if (this.config.runningInAngularJS) {
      /*
      Important Note:
      This is needed to remove primengs dynamic dialog from the DOM. For some reason, the component that
      registers the initial opening of the dialog can't seem to close it. This only happens in our AngularJS
      framework.
      */
      // @ts-ignore
      jQuery('p-dynamicdialog').remove();
    }

    // Create the MacMillan Group and redirect if needed:
    this.BulbGroupService.createMacMillanGroup(this.selectedBook).then((macMillanGroup) => {
      // Navigate to the MacMillan group
      // @ts-ignore
      if (this.config.redirectToGroup) {
        this.state.go('group', { groupUrl: macMillanGroup.url }, { location: 'replace' });
      }
    });
  }
}
